import { Icon, IconProps } from "../";

export const ClockIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 6.48 6.47 2 11.99 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 11.99 22C6.47 22 2 17.52 2 12ZM3.5 12C3.5 16.6962 7.30375 20.5 12 20.5C16.6962 20.5 20.5 16.6962 20.5 12C20.5 7.30375 16.6962 3.5 12 3.5C7.30375 3.5 3.5 7.30375 3.5 12ZM11.25 7.5C11.25 7.08579 11.5858 6.75 12 6.75C12.4142 6.75 12.75 7.08579 12.75 7.5V12.5C12.75 12.9142 12.4142 13.25 12 13.25H11.25H7.5C7.08579 13.25 6.75 12.9142 6.75 12.5C6.75 12.0858 7.08579 11.75 7.5 11.75H11.25V7.5Z"
      />
    </Icon>
  );
};
